package com.cybersoftsolution.cybersoftsolutionweb.components.switchs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.MyCheckBoxStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Switch
import com.varabyte.kobweb.silk.components.forms.SwitchSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun MySwitch(
    isChecked: Boolean? = false,
    visible: Boolean = true,
    modifier: Modifier = Modifier,
    text: String,
    onChange: (Boolean) -> Unit = {}
) {


    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center,
        modifier = modifier
            .then(
                MyCheckBoxStyle.toModifier()
                    .cursor(Cursor.Pointer)
                    .borderRadius(24.px)
                    .height(34.px)
                    .onClick {
                        isChecked?.let {
                            onChange(!it)
                        }
                    }

            )
            .visibility(if (visible) Visibility.Visible else Visibility.Hidden)

    ) {
        Switch(
            focusBorderColor = Theme.Primary.rgb,
            checked = isChecked?:false,
            modifier = Modifier
                .margin(right = 12.px)
            ,
            onCheckedChange = {
                isChecked?.let {
                    onChange(!it)
                }
            },
            size = SwitchSize.LG
        )
        SpanText(
            modifier = Modifier
                .margin(right = 8.px)
                .fontSize(16.px)
                .fontFamily("FONT_FAMILY")
                .color(Theme.HalfBlack.rgb)
            ,
            text = text
        )
    }
}